import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "App.net put a price on early adopter pride. And it worked.",
  "description": "",
  "published": "2012-08-14T00:00:00.000Z",
  "redirect_from": ["/blog/app-net-put-a-price-on-early-adopter-pride-and-it-worked/swizec/5066"],
  "categories": "Dalton, Early adopter, Instagram, Online Communities, Social network, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/dapeel/157384488/sizes/z/in/photostream/"
      }}><img parentName="a" {...{
          "src": "https://farm1.staticflickr.com/55/157384488_a42dfd77b9_z.jpg?zz=1",
          "alt": "Image by  dapeel",
          "title": "Image by  dapeel"
        }}></img></a></p>
    <p>{`How does it feel to be the first guy at the party? It's kind of lame.`}</p>
    <p>{`There's nobody to talk to, lonely in the corner you sit, sipping on your drink and look with longing eyes at everyone who comes in. They know. You know they know. `}<em parentName="p">{`You`}</em>{` were there first, you're that loser who's got nothing better to do. Nowhere else to be. The guy who's life is so empty and lonely that you would `}<em parentName="p">{`rush`}</em>{` to a party and be there first.`}</p>
    <p>{`Nobody wants to be that guy.`}</p>
    <p>{`Unless we're talking about tech products and social networks and cool web-point-gazillion websites and spanking new technology!`}</p>
    <p>{`Suddenly, `}<em parentName="p">{`everyone`}</em>{` wants to be an early adopter. They want to be that guy who discovered the service first. That guy who was the first in line for the beta.`}</p>
    <p>{`That guy who was first to predict that `}<strong parentName="p">{`this thing is going to be huge!`}</strong></p>
    <p>{`It feels awesome, nay, magnificent to feel like you were `}<em parentName="p">{`that guy`}</em>{`. That guy who convinced all of their friends to start using this new fangled service that until yesterday lived only in the head of some dreamer.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/Selection_068.png",
        "alt": "I am an early adopter - Idego.co",
        "title": "I am an early adopter - Idego.co"
      }}></img></p>
    <p>{`There is an immense sense of pride in that. When the service `}<em parentName="p">{`does`}</em>{` succeed it feels like you were part of the success. You, with your measly network of two or three thousand twitter followers, with your blog that even your grandma reads. You were the key driver of success of this new idea you believed in as the first user.`}</p>
    <p>{`No, you don't get any equity for that.`}</p>
    <p>{`No, you don't even get any money.`}</p>
    <p>{`You get a bit of street cred. Maybe.`}</p>
    <p>{`What you do certainly get is a crappy service, where you are alone, sitting in a corner, sipping your drink, and positively gleaming in the pride that you were there first. If nobody else comes to the party, you will never speak of this again. You always knew that party was going to suck anyway.`}</p>
    <p>{`But if it works, you were `}{`_`}{`the `}{`_`}{`guy who made the party work. Not the 500,000 other guys who were also there first. Oh no, not them. You.`}</p>
    <h2 {...{
      "id": "appnet"
    }}>{`app.net`}</h2>
    <p>{`And that's exactly what `}<a parentName="p" {...{
        "href": "http://app.net"
      }}>{`app.net`}</a>{` cashed in on.`}</p>
    <p>{`They gave everyone the opportunity to `}<em parentName="p">{`buy`}</em>{` an account. To buy a username and be granted forever more the rights granted by the title of `}<em parentName="p">{`Early Adopter`}</em>{` - passed on by heritage on the mother's side. Forever known as those guys who were first to the party, who `}<em parentName="p">{`knew`}</em>{` the service was going to be big. They were so confident in fact that they even put their money where their mouth is.`}</p>
    <p>{`And that's amazing. Hat's off to `}<a parentName="p" {...{
        "href": "http://twitter.com/daltonc"
      }}>{`Dalton`}</a>{` and his team. They managed to put a price on that most intangible of feelings - the pride of being an early adopter. The enthusiasm of being a part of the story.`}</p>
    <p>{`I almost signed up as well.`}</p>
    <p>{`The moment they announced having reached the funding goal; I went through all the steps for making an account. I cover myself in shame for not believing in this idea sooner.`}</p>
    <p>{`But when it came to `}<em parentName="p">{`"Hey, give us `}{`\\`}{`\\`}{`\\`}{`\\`}{`$50 per year"`}</em>{`. I said to myself, fuck that. You know what, this great feeling isn't worth it. I'd rather go buy some drugs instead. It amounts to the same - pay for a service that makes you feel great, maybe, or pay for some chemicals that will make you feel great, definitely.`}</p>
    <p>{`Are all those people getting anything else for their money? No.`}</p>
    <p>{`So here's an idea for the next app.net, and there `}<em parentName="p">{`will`}</em>{` be a next app.net, people love taking money from suckersusers. Sell an account for $100 a year (or whatever), but the first 1000 users also get 0.001% equity.`}</p>
    <p>{`They're pretty much founders/investors anyway, why not reward them as such?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://phuu.net/2012/08/12/what-i-see-in-app-dot-net.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_17_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://phuu.net/2012/08/12/what-i-see-in-app-dot-net.html"
        }}>{`What I see in App.net`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.cultofmac.com/183092/are-you-an-early-adopter-find-out-how-fast-you-signed-up-to-twitter-instagram-and-more/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/105146395_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.cultofmac.com/183092/are-you-an-early-adopter-find-out-how-fast-you-signed-up-to-twitter-instagram-and-more/"
        }}>{`Are You An Early Adopter? Find Out How Fast You Signed Up To Twitter, Instagram And More`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thenextweb.com/shareables/2012/08/06/so-you-think-youre-an-early-adopter-find-out-just-how-early-with-this-site/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/104809840_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://thenextweb.com/shareables/2012/08/06/so-you-think-youre-an-early-adopter-find-out-just-how-early-with-this-site/"
        }}>{`So you think you're an early adopter? Find out just how "early" with this site`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.siliconrepublic.com/new-media/item/28764-more-than-12-000-backers-su"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/106578869_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.siliconrepublic.com/new-media/item/28764-more-than-12-000-backers-su"
        }}>{`More than 12,000 backers support ad-free paid-for social platform App.net`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.iamdann.com/2012/08/13/app-net-is-not-the-answer-and-why-i-gave-them-money"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_98_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.iamdann.com/2012/08/13/app-net-is-not-the-answer-and-why-i-gave-them-money"
        }}>{`App.net is Not the Answer, and Why I Gave Them Money`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=10ee57ac-4cb2-4069-9116-aff6611d010d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      